<script>
export default {
    name: 'IconTeacher',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-teacher"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M47.712 23.495c.11.068.207.154.288.255.636.795.904 1.824.737 2.829l-2.569 15.42C43.62 50.114 36.04 56 27.084 56 18.13 56 10.55 50.114 8 42c2.548-8.114 10.129-14 19.084-14a19.92 19.92 0 0113.368 5.124L40.5 33l5.657-9.139a1.13 1.13 0 011.555-.366zM27.416 34c-2.945 0-5.332 2.225-5.332 4.966V50h3.851v-4.414h2.963V50h3.853V38.966c0-2.741-2.39-4.966-5.335-4.966zm0 3.585c.818 0 1.482.62 1.482 1.38v3.31h-2.963v-3.31c0-.76.663-1.38 1.48-1.38zM27.084 8a8 8 0 110 16 8 8 0 010-16zM48 16v4h-8v-4h8zm8-8v4H40V8h16z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
